import { useTranslation } from 'react-i18next'

import { AirplaneLanding } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelDestination = ({ addressText }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <AirplaneLanding size={24} /> <Text type="bodyMBold">{t('Destino')}:</Text>{' '}
      <Text type="bodyMRegular">{addressText}</Text>
    </Styles.Container>
  )
}

export default ParcelDestination
